export default "__VITE_ASSET__584138a9__"